const buildFinalAddress = ({ streetLine, secondary, city, state, zipcode, entries }) => {
  if (entries > 1) {
    return `${streetLine} ${secondary} (${entries}) ${city} ${state} ${zipcode}`;
  }
  return `${streetLine} ${secondary} ${city} ${state} ${zipcode}`;
};

export default buildFinalAddress;
